/* Header behaviour (mobile drawer, mega-menus, search panel, sticky logo). Moved out of sections/pp-header.liquid on
   2026-10-03 so it is cached across pages (~14KB per page view). Plain blocking tag: same timing as before. */
  (function () {
    // ===== Mobile drawer =====
    var menuTrigger = document.querySelector('[data-pp-menu-trigger]');
    var drawer = document.getElementById('pp-mobile-menu');
    if (menuTrigger && drawer) {
      menuTrigger.addEventListener('click', function () {
        var open = drawer.getAttribute('data-open') === 'true';
        drawer.setAttribute('data-open', String(!open));
        drawer.hidden = open;
        menuTrigger.setAttribute('aria-expanded', String(!open));
        var hd = document.querySelector('[data-pp-header]');
        if (window.ppLogoGeom) window.ppLogoGeom();
        if (hd) { if (open) hd.removeAttribute('data-drawer-open'); else hd.setAttribute('data-drawer-open', ''); }
      });
    }

    // ===== Mega-menu open/close =====
    var header = document.querySelector('[data-pp-header]');
    if (!header) return;
    var tabGroups = header.querySelectorAll('.pp-header__tab-group[data-pp-tab]');
    var closeTimer = null;
    var OPEN_DELAY = 50;
    var CLOSE_DELAY = 180;

    // The basket preview and the search panel live INSIDE the header, so hovering them never fires the header's
    // own mouseleave and a mega-menu stayed open behind them. Keep the three mutually exclusive.
    function closeMiniCart() {
      var mc = document.querySelector('[data-pp-mc]');
      if (mc && mc.classList.contains('is-open')) { mc.classList.remove('is-open'); mc.hidden = true; }
    }

    function openMenu(name) {
      clearTimeout(closeTimer);
      closeMiniCart();
      if (window.ppLogoGeom && !header.hasAttribute('data-open-menu')) window.ppLogoGeom();
      header.setAttribute('data-open-menu', name);
      tabGroups.forEach(function (g) {
        var match = g.dataset.ppTab === name;
        g.querySelector('.pp-header__tab').setAttribute('aria-expanded', match ? 'true' : 'false');
      });
      // aria-hidden on panels
      header.querySelectorAll('.pp-header__megamenu').forEach(function (m) {
        m.setAttribute('aria-hidden', m.dataset.menu === name ? 'false' : 'true');
      });
    }
    function closeMenu() {
      header.removeAttribute('data-open-menu');
      tabGroups.forEach(function (g) {
        g.querySelector('.pp-header__tab').setAttribute('aria-expanded', 'false');
      });
      header.querySelectorAll('.pp-header__megamenu').forEach(function (m) {
        m.setAttribute('aria-hidden', 'true');
      });
    }

    tabGroups.forEach(function (group) {
      var name = group.dataset.ppTab;

      // Hover (desktop): open after a tiny delay so tab-to-tab scan doesn't flicker
      group.addEventListener('mouseenter', function () {
        clearTimeout(closeTimer);
        setTimeout(function () { openMenu(name); }, OPEN_DELAY);
      });

      // Focus: keyboard nav opens menu
      group.querySelector('.pp-header__tab').addEventListener('focus', function () {
        clearTimeout(closeTimer);
        openMenu(name);
      });
    });

    header.addEventListener('mouseleave', function () {
      closeTimer = setTimeout(closeMenu, CLOSE_DELAY);
    });

    // Moving onto the search or basket icon (or into the basket preview) closes any open mega-menu.
    header.querySelectorAll('.pp-header__icon-btn').forEach(function (btn) {
      btn.addEventListener('mouseenter', closeMenu);
      btn.addEventListener('focus', closeMenu);
    });
    document.addEventListener('mouseenter', function (e) {
      if (e.target && e.target.closest && e.target.closest('[data-pp-mc]')) closeMenu();
    }, true);

    // Click outside / Escape closes
    document.addEventListener('click', function (e) {
      if (!header.contains(e.target)) closeMenu();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeMenu();
    });

    // ===== Search panel (type-ahead) =====
    // Results come from sections/pp-predictive-search.liquid via Shopify's
    // Section Rendering on /search/suggest, so prices/images/crops are all Liquid-side.
    var searchTrigger = header.querySelector('[data-pp-search-trigger]');
    var searchPanel   = header.querySelector('[data-pp-search]');
    var searchScrim   = header.querySelector('[data-pp-search-scrim]');
    var searchForm    = header.querySelector('[data-pp-search-form]');
    var searchInput   = header.querySelector('[data-pp-search-input]');
    var searchResults = header.querySelector('[data-pp-search-results]');

    if (searchTrigger && searchPanel && searchInput && searchResults) {
      var SEARCH_URL = window.ppSearchUrl || '/search/suggest';
      var debounceTimer = null;
      var reqToken = 0;
      var lastTerm = '';

      function searchOptions() {
        return Array.prototype.slice.call(searchResults.querySelectorAll('[data-pp-search-option]'));
      }
      function clearActive() {
        searchOptions().forEach(function (el) { el.removeAttribute('data-pp-active'); });
      }
      function moveActive(dir) {
        var opts = searchOptions();
        if (!opts.length) return;
        var idx = opts.findIndex(function (el) { return el.hasAttribute('data-pp-active'); });
        clearActive();
        idx = idx + dir;
        if (idx < 0) { searchInput.focus(); return; }
        if (idx >= opts.length) idx = opts.length - 1;
        opts[idx].setAttribute('data-pp-active', '');
        opts[idx].scrollIntoView({ block: 'nearest' });
      }

      function openSearch() {
        closeMenu();
        searchPanel.hidden = false;
        if (searchScrim) searchScrim.hidden = false;
        searchTrigger.setAttribute('aria-expanded', 'true');
        searchInput.focus();
        searchInput.select();
      }
      function closeSearch() {
        searchPanel.hidden = true;
        if (searchScrim) searchScrim.hidden = true;
        searchTrigger.setAttribute('aria-expanded', 'false');
      }

      function renderStatus(msg) {
        searchResults.innerHTML = '<p class="pp-search__status">' + msg + '</p>';
      }

      function fetchResults(term) {
        var token = ++reqToken;
        var url = SEARCH_URL
          + '?q=' + encodeURIComponent(term)
          + '&section_id=pp-predictive-search'
          + '&resources[type]=product,collection,query'
          + '&resources[limit]=6'
          + '&resources[limit_scope]=each'  // 6 posters + their own suggestions (the default shares the 6)
          + '&resources[options][unavailable_products]=last';

        fetch(url)
          .then(function (r) {
            if (!r.ok) throw new Error(r.status);
            return r.text();
          })
          .then(function (html) {
            if (token !== reqToken) return;  // a newer keystroke already won
            searchResults.innerHTML = html;
          })
          .catch(function () {
            if (token !== reqToken) return;
            renderStatus('Search is unavailable right now. Press Enter to search the whole store.');
          });
      }

      searchTrigger.addEventListener('click', function (e) {
        e.stopPropagation();
        if (searchPanel.hidden) openSearch(); else closeSearch();
      });

      var searchClose = header.querySelector('[data-pp-search-close]');
      if (searchClose) searchClose.addEventListener('click', closeSearch);
      if (searchScrim) searchScrim.addEventListener('click', closeSearch);

      searchInput.addEventListener('input', function () {
        var term = searchInput.value.trim();
        if (term === lastTerm) return;
        lastTerm = term;
        clearTimeout(debounceTimer);
        if (term.length < 2) {
          reqToken++;                 // cancel any in-flight render
          searchResults.innerHTML = '';
          return;
        }
        debounceTimer = setTimeout(function () { fetchResults(term); }, 220);
      });

      searchInput.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown') { e.preventDefault(); moveActive(1); }
        else if (e.key === 'ArrowUp') { e.preventDefault(); moveActive(-1); }
      });

      searchPanel.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown') { e.preventDefault(); moveActive(1); }
        else if (e.key === 'ArrowUp') { e.preventDefault(); moveActive(-1); }
      });

      // Enter with a highlighted result follows it; otherwise submit to /search
      if (searchForm) {
        searchForm.addEventListener('submit', function (e) {
          var active = searchResults.querySelector('[data-pp-search-option][data-pp-active]');
          if (active) {
            e.preventDefault();
            window.location.href = active.href;
            return;
          }
          if (!searchInput.value.trim()) e.preventDefault();
        });
      }

      // Escape closes the panel; click outside closes it too
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !searchPanel.hidden) {
          closeSearch();
          searchTrigger.focus();
        }
      });
      document.addEventListener('click', function (e) {
        if (searchPanel.hidden) return;
        if (!searchPanel.contains(e.target) && e.target !== searchTrigger) closeSearch();
      });
    }

    // ===== Logo morph geometry (transform-only animation) =====
    // Measure the big logo in its resting place and work out the translate/scale that lands its book stack on the
    // compact stack (centred in the bar), and the inverse for the stack-only image. Re-measured on resize.
    var lgImg = header.querySelector('.pp-header__logo-img'), lgStack = header.querySelector('.pp-header__logo-stack');
    var lgInner = header.querySelector('.pp-header__inner');
    function logoGeom () {
      if (!lgImg || !lgStack || !lgInner) return;
      var H = lgImg.offsetHeight, top = lgImg.offsetTop, innerH = lgInner.clientHeight;
      if (!H || !innerH) return;
      var mobile = window.innerWidth <= 900;
      var S = Math.max(34, Math.min(mobile ? 44 : 56, innerH - (mobile ? 14 : 18)));   // compact stack height
      var stackBase = 0.552 * H, cyBase = top + 0.421 * H, cyTarget = innerH / 2;
      var k = S / stackBase;
      header.style.setProperty('--pp-st-h', S + 'px');
      header.style.setProperty('--pp-lg-k', k.toFixed(4));
      header.style.setProperty('--pp-lg-dy', (cyTarget - cyBase).toFixed(1) + 'px');
      header.style.setProperty('--pp-st-k0', (1 / k).toFixed(4));
      header.style.setProperty('--pp-st-dy0', (cyBase - cyTarget).toFixed(1) + 'px');
    }
    if (lgImg) { if (lgImg.complete) logoGeom(); lgImg.addEventListener('load', logoGeom); }
    window.addEventListener('load', logoGeom);
    window.addEventListener('resize', logoGeom);
    window.ppLogoGeom = logoGeom;

    // Word widths for the equal-gap tab spacing (see .pp-header__tabs CSS). 0 when the words are hidden.
    var lwL = header.querySelector('.pp-header__lw--l'), lwR = header.querySelector('.pp-header__lw--r');
    function lwMeasure () {
      if (!lwL || !lwR) return;
      header.style.setProperty('--lw-l', lwL.offsetWidth + 'px');
      header.style.setProperty('--lw-r', lwR.offsetWidth + 'px');
    }
    lwMeasure();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(lwMeasure);
    window.addEventListener('load', lwMeasure);
    window.addEventListener('resize', lwMeasure);

    // ===== Sticky on scroll =====
    var sticky = false;
    var spacer = null;
    var headerH = header.offsetHeight;
    // Threshold: anything past the discount banner (which sits above the header)
    var bannerEl = document.querySelector('.pp-discount-banner-section');
    var THRESHOLD = bannerEl ? bannerEl.offsetHeight + 8 : 60;

    // rAF-throttled, with a little hysteresis so it can't flicker on/off around the threshold (iOS bounce).
    var ticking = false;
    function update () {
      ticking = false;
      var y = window.scrollY || window.pageYOffset;
      if (y > THRESHOLD + 12 && !sticky) {
        sticky = true;
        headerH = header.offsetHeight;
        // Insert a same-height spacer so layout doesn't jump when header goes fixed
        spacer = document.createElement('div');
        spacer.setAttribute('data-pp-header-spacer', '');
        // display:block matters: Dawn's base.css hides every empty div (div:empty { display: none }), which collapsed
        // this spacer to 0px — the page jumped up by the header's height (122px on phones with the search bar) each
        // time the header stuck, and back down when it unstuck. That was the "glitchy" mobile scroll (2026-09-25).
        spacer.style.display = 'block';
        spacer.style.height = headerH + 'px';
        spacer.style.overflowAnchor = 'none';
        // Measure the logo FIRST (resting state, as before), then swap header -> spacer in one step with no layout read
        // in between. Measuring while both were in the flow let the browser's scroll anchoring push the page ~160px
        // down on phones as the header stuck.
        if (window.ppLogoGeom) window.ppLogoGeom();
        header.parentNode.insertBefore(spacer, header);
        header.setAttribute('data-stuck', 'true');
      } else if (y <= THRESHOLD && sticky) {
        sticky = false;
        header.removeAttribute('data-stuck');
        if (spacer && spacer.parentNode) spacer.parentNode.removeChild(spacer);
        spacer = null;
        closeMenu();  // close any open mega-menu when un-sticking
      }
    }
    function onScroll () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }
    window.addEventListener('scroll', onScroll, { passive: true });
    var lastW = window.innerWidth;
    window.addEventListener('resize', function () {
      // Keep the spacer matched to the header's normal height when the WIDTH changes (rotation). iOS also fires resize
      // as the address bar hides/shows (height only) — ignored, the header height doesn't change then.
      if (window.innerWidth === lastW) return;
      lastW = window.innerWidth;
      if (sticky && spacer) {
        header.removeAttribute('data-stuck'); headerH = header.offsetHeight; header.setAttribute('data-stuck', 'true');
        spacer.style.height = headerH + 'px';
      }
    });
  })();
